import { PropsWithChildren, useState } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { Lead } from "@/types";
import { FormLead } from "./form-lead";
import { ContactConsentChip } from "@/components/consent/ContactConsentChip";

type FormLeadModalProps = PropsWithChildren & {
  lead?: Lead;
  openDrawer?: boolean;
  disable?: boolean;
};

export function FormLeadModal({
  children,
  lead,
  disable
}: FormLeadModalProps) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
    <DialogResponsive
      title={lead ? "Atualizar lead" : "Novo lead"}
      description={
        lead
          ? "Preencha os campos para atualizar o lead."
          : "Preencha os campos para criar um novo lead."
      }
      button={children}
      disable={disable}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >
      {lead && (
        <div className="pb-2">
          <ContactConsentChip subjectType="lead" subjectId={lead.id} />
        </div>
      )}
      <FormLead lead={lead} handleClose={handleClose} />
    </DialogResponsive>
  );
}